export const LOGIN_USER = "login_user";
export const AUTH_USER = "auth_user";
export const LOGOUT_USER = "logout_user";
export const AUTH_VENDOR = "auth_vendor";
export const UPLOAD_JSONDATA = "upload_jsondata";
export const DICTIONARY = "dictionary";
export const ERROR_MODAL = "error_modal";
